import './BulletList.css';

interface BulletListProps {
  description: string;
};
/**
 * Used for checking if Property Description contains bullet points
 */
export default function BulletList({description}: BulletListProps) {
  const splitDescription = description
    .split('\u2022')
    .map(line => line.trim())
    .filter(line => line);
  return (
    <ul>
      {splitDescription.map((line, i) => (
        <li key={`summary-description--bullet-${i + 1}`}>
          {line}
        </li>
      ))}
    </ul>
  );
}

export function checkForBulletPoints(str: string | undefined) {
  if (!str) return false;
  return str.includes('\u2022');
}